import { Cog6ToothIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../core/hooks/useTranslation'

interface ManageButtonProps<T = any> {
  onClick: (item: T) => void
  item: T
  className?: string
  showLabel?: boolean
}

export default function ManageButton<T = any>({
  onClick,
  item,
  className = '',
  showLabel = true
}: ManageButtonProps<T>) {
  const { t } = useTranslation()

  return (
    <button
      onClick={() => onClick(item)}
      className={`border border-gray-300 px-3 py-1 gap-1 text-sm text-[#1E293B] hover:text-[#1E293B] hover:border-[#1E293B] hover:bg-gray-50 disabled:cursor-not-allowed flex items-center justify-center rounded-l transition-colors ${className}`}
      title={t('manage')}
    >
      <Cog6ToothIcon className="w-3.5 h-3.5" />
      {showLabel && <span>{t('manage')}</span>}
    </button>
  )
}

